export const isAutomatedTests = (): boolean => {
    // Check localStorage flag
    if (localStorage.getItem('IS_AUTOMATED_TESTS') === 'true') {
        return true;
    }

    // Check if user email starts with 'auto_test-' (for staging/CI environments)
    try {
        // Access UserState via global IOC container
        const global: any = window;
        if (global.IOC) {
            const userState = global.IOC.get('UserState');
            if (userState && userState.state && userState.state.email) {
                return userState.state.email.startsWith('auto_test-');
            }
        }
    } catch (error) {
        // If UserState access fails, fall back to false
        return false;
    }

    return false;
};
